import React from "react";
import { Auth } from "aws-amplify";

// Component imports
import { DialogButton } from "@components";
import { RocketIcon } from "@icons";
import { Paper, Typography } from "@material";

// Misc Imports

import { useTranslation } from "@i18n";
import { makeStyles } from "@styles";
import { AuthUtils, ModalHelper, navigate } from "@utils";

const useStyles = makeStyles((theme: Theme) => ({
  paper: {
    width: "auto",
    height: "auto",
    padding: 32,
    outline: "none !important",
    [theme.breakpoints.down("xs")]: {
      margin: "auto 16px auto 16px",
    },
  },
  insideContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    height: "auto",
    width: 300,
    borderRadius: 8,
    marginLeft: "auto",
    marginRight: "auto",
    [theme.breakpoints.down("xs")]: {
      height: "auto",
      width: "90%",
    },
  },
  titleText: {
    fontSize: 24,
    fontWeight: 600,
    textAlign: "center",
    marginTop: 16,
    marginLeft: "auto",
    marginRight: "auto",
  },
  successText: {
    fontSize: 18,
    textAlign: "center",
    marginTop: 16,
    marginLeft: "auto",
    marginRight: "auto",
    marginBottom: 16,
  },
}));

interface Props {
  handleRedirectToSignIn: () => void;
}

export function PasswordChangedSuccessModal({ handleRedirectToSignIn }: Props) {
  const classes: any = useStyles({});
  const { t } = useTranslation(["profile", "common"]);

  return (
    <Paper className={classes.paper}>
      <div className={classes.insideContainer}>
        <RocketIcon />
        <Typography className={classes.titleText}>
          {t("modals.changePasswordSuccess.passwordChanged")}
        </Typography>
        <Typography className={classes.successText}>
          {t("modals.changePasswordSuccess.successText.one")}
        </Typography>
        <DialogButton
          colorVariant="pink"
          width="100%"
          onClick={handleRedirectToSignIn}
        >
          {t("modals.changePasswordSuccess.successText.two")}
        </DialogButton>
      </div>
    </Paper>
  );
}
